module.exports = __webpack_public_path__ + "img/bg6.ffa17028.png";